import { SelectOption } from '@/models/generics'
import { CtCategory } from '@/models/interfaces/content-type'
import { RequestQueryItem, ServiceRequestConfig, UUID } from '@Protium/vue-ozone-utils'
import { computed, onMounted, Ref, ref } from 'vue'
import { Store } from 'vuex'
import useContentModule from './useContentModule'

export default function useCategoryFilter<S = any> ($store:Store<S>, items:Ref<Array<any>>, fetcher: (query?:Array<RequestQueryItem>, config?: ServiceRequestConfig) => Promise<any>, field = 'categories', select = ['title', 'sku', 'images', 'categories'], method = 'in', query:Array<RequestQueryItem> = []) {
  const {
      items: categories,
      fetch
  } = useContentModule<CtCategory>('Categories', $store)

  const activeCategories = ref<Array<UUID | SelectOption>>([])

  function toggleCategory (option: {label: string, value: any}) {
    // const index = activeCategories.value.findIndex(c => c === option.value)
    // if(index >= 0) activeCategories.value.splice(index, 1)
    // else activeCategories.value.push(option)

    void fetchByActiveCategories()
  }

  const filteredItems = computed({
    get: () => {
      if (!activeCategories.value?.length) return items.value
      const filtered = (items.value || []).filter(item => {
        return activeCategories.value.some(ac => item.categories?.map(c => typeof c === 'string' ? c : (c as CtCategory)?.sys?.id).includes(typeof ac === 'string' ? ac : ac.value))
      })

      // if(filtered?.length <= 10 && activeCategories.value?.length) void fetchByActiveCategories()
      return filtered
    },
    set: (value) => {
      // console.log('filteredItems setter', value)
    }
  })

  const fetchByActiveCategories =  () => {
    // HOTFIX: added type: 'uuid' assuming we're always filtering based on a rel field (uuid[]) like categories
    return !activeCategories.value?.length
    ? fetcher([{ select }], { limit: 100, resolve: 2 }).catch(console.error)
    : fetcher([{field, method, type: 'uuid', match: activeCategories.value?.map(s => typeof s === 'string' ? s : s.value)}, { select }], { limit: Math.min(1000, activeCategories.value?.length * 50), resolve: 2 })
      .catch(console.error)
  }

  const options = computed(() => categories.value.map(c => ({label: c.label || c.name, value: c.sys.id, sys: c.sys})))

  onMounted(() => {
    fetch(query, {limit: 100}).catch(console.error)
  })

  return {
    toggle: toggleCategory,
    items: filteredItems,
    options,
    active: activeCategories,
    categories,
    fetch
  }
}
